import { DateTime } from "luxon";
import { AccessInfo, Chat, ExternalObserverSessionInfo, Mentor, Order, Registration, SessionPhoto } from "../Shared/GeneratedTypes";
import * as Shared from "../Shared/sharedTypes";

export interface ApplicationData extends Shared.SharedApplicationData {
    localizations: Shared.Localizations;
    currentPhase: ClientPhase;
    order: Order;
    chats: Chat[];
    photos: SessionPhoto[];
    registrations: Registration[];
    photoRequests: any;
    numberInQueue: number | null;
    mentor: Mentor | null;
    estimatedStart: Date | null;
    haveNetworkAccess: boolean;
    permissions: Permissions;
    apiCallsInProgress: number;
    liveSwitchState: Shared.LiveSwitchState;
    accessInfo: AccessInfo;
    currentPosition: Position | null;
    liveSwitchToken: string | null;
    deviceId: string;
    invalidCode: boolean;
    canLeave: boolean;
    scheduleSlots: DateTime[] | null;
    fullscreen: false;
    activeObservers: Shared.ObserverState;
    activeMentee: boolean;
    recordingState: boolean;
    onPremiseSettings: Shared.OnPremiseSettings;
    externalObservers: ExternalObserverSessionInfo[];
}

export interface Permissions {
    haveCameraAccess: PermissionState;
    haveLocationAccess: PermissionState;
}

export enum ClientPhase {
    Welcome,
    Privacy,
    WhatToExpect,
    Permissions,
    AccessDenied,
    Photo,
    Scheduling,
    ScheduleConfirmation,
    Queue,
    MeetYourMentor,
    GuideStreamOnline,
    GuideStreamOffline,
    SessionEndedTemporarily,
    SessionEnded,
    Review,
    ProvideFeedback,
    MenteeAlreadyLoggedIn,
    CookieDisclosure,
    Removed
}
